import { useDispatch, useSelector } from 'react-redux';
import UpdateProposal from '../../components/module/proposal-status/modal/update-proposal';
import SearchFilterBar from '../../components/ui/search-filter-bar';
import ProposalTHead from '../../components/ui/proposal-thead';
import ProposalListTBody from '../../components/module/proposal-status/proposal-list-tbody';
import Pagination from '../../components/ui/pagination';
import ProposalActionModal from '../../components/module/proposal-status/modal/preview-proposal/proposal-action-modal';
import { useProposalTable } from '../../hooks/proposal/use-proposal-table';
import ProposalDetails from '../../components/module/proposal-status/modal/proposal-details';
import SectionHeader from '../../components/ui/section-header';
import { proposalHeaderData } from '../../constant/gms-constant';
import NotesAmendmentConfirmation from '../../components/module/proposal-status/modal/notes-amendment-confirmation';
import { selectAmendmentModalOne, setAmendmentModalOne, setHasProposedData, setNotesReason, setOldProposalData } from '../../features/actuarial/request-amendment/request-amendment.slice';
import { useRequestAmendment } from '../../hooks/actions/use-request-amendment-actions';
import { setCurrentStep } from '../../features/gms-proposal-forms/steps-channel-proposal_as/steps-channel-proposal_as.slice';
import ComputationDetails from '../../components/module/proposal-computation/modal/others/computation-details';
import { useFilesActions } from '../../hooks/actions/use-files-actions';
import { useModalAccess } from '../../components/global/modal/use-modal-access';

export default function StatusProposalPage() {
    
    const dispatch = useDispatch()
    const {
        isShowProposalDetails,
        isUpdateProposal,
        isShowComputationDetails,
        isShowActionProposalModal,
    } = useModalAccess()
    const { handleViewProposal } = useFilesActions();
    const {
        normalizedOptions,
        errorMessage,
        searchType,
        setSearchType,
        searchValue,
        setSearchValue,
        setPage,
        pagedData,
        loading,
        isErrorGetProposal,
        handleReload,
        getProposal,

        defaultTotalPages,
        proposalDefaultPageSize,
        handleChangePageSize
    } = useProposalTable();
    const { handleRequestAmendment, isLoadingRequestAmendment } = useRequestAmendment()
    // const totalThisMonth = getCurrentMonthProposalTotal(getProposal?.data)
    // const totalLapseThisMonth = getLapseThisMonthTotal(getProposal?.data)
    // const totalProposal = getProposal?.data?.length ?? 0
    const amendmentModalOne = useSelector(selectAmendmentModalOne)

    const tHeads:string[] = [
        proposalHeaderData.proposalStatus.label,
        proposalHeaderData.proposalAs.label,
        proposalHeaderData.groupName.label,
        proposalHeaderData.proposalType.label,
        proposalHeaderData.product.label,
        // proposalHeaderData.email.label,
        proposalHeaderData.preparedBy.label,
    ];

    return (
        <div className="flex h-full min-h-0 w-full flex-col bg-[#f8fafc] rounded-xl border border-gray-200">
            <div className="flex min-h-0 flex-1 flex-col overflow-hidden">
                <SectionHeader
                    title='Proposal Management'
                    subtitle='View and monitor the current status of submitted proposals.'
                    icon={
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="h-4 w-4">
                            <rect x="5" y="3" width="14" height="18" rx="2" />
                            <path d="M9 8h6M9 12h6M9 16h3" />
                        </svg>
                    }
                />
                <div className="mx-auto flex min-h-0 w-full flex-1 flex-col gap-2">
                    <div className="flex min-h-0 flex-1 flex-col overflow-hidden bg-white shadow-sm">
                        <div className="shrink-0 border-b border-gray-200 p-3">
                            {/* SEARCH & FILTER */}
                            <SearchFilterBar
                                searchType={searchType}
                                setSearchType={setSearchType}
                                searchValue={searchValue}
                                setSearchValue={setSearchValue}
                                options={normalizedOptions}
                            />
                        </div>
                        {getProposal?.pagination && (
                            <div className="shrink-0 border-b border-gray-200 bg-gray-50/60 p-2 sm:p-3">
                                <Pagination
                                    setPage={setPage}
                                    handleReload={handleReload}
                                    pagination={getProposal.pagination}
                                    defaultTotalPages={defaultTotalPages}
                                    setDefaultTotalPages={handleChangePageSize}
                                    totalPagesOptions={proposalDefaultPageSize}
                                />
                            </div>
                        )}
                        {/* TABLE */}
                        <div className="min-h-0 flex-1 overflow-auto">
                            <table className="min-w-max w-full border-collapse">
                                <ProposalTHead headers={tHeads} />
                                <ProposalListTBody
                                    headers={tHeads}
                                    typeOfIcon="update"
                                    isLoadingGetProposal={loading}
                                    isErrorGetProposal={isErrorGetProposal}
                                    errorMessage={errorMessage}
                                    getProposal={pagedData}
                                    handleEdit={handleViewProposal}
                                />
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            {/* ================================================= */}
            {/* MODALS */}
            {/* ================================================= */}
            {isShowActionProposalModal && <ProposalActionModal typeOfIcon="update"/>}
            {isShowProposalDetails && <ProposalDetails/>}
            {isShowComputationDetails && <ComputationDetails/>}
            {amendmentModalOne === 'isRequesting' && (
                <NotesAmendmentConfirmation
                    modalTitle="Amendment Request"
                    modalSubTitle="Provide a note describing the required amendments before submitting the request."
                    confirmTitle={'Continue Request'}
                    onCancel={() => {
                        dispatch(setAmendmentModalOne(null))
                        dispatch(setNotesReason(''))
                        dispatch(setOldProposalData(null))
                        dispatch(setHasProposedData(false))
                        dispatch(setCurrentStep(1));
                    }}
                    onConfirm={handleRequestAmendment}
                    isLoading={isLoadingRequestAmendment}
                    type='request'
                />
            )}
            {isUpdateProposal && <UpdateProposal />}
        </div>
    );
}